export enum BlockPosition {
	top = 'pos-top',
	bottom = 'pos-bottom',
	left = 'pos-left',
	right = 'pos-right',
}
